var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.234H7.2476C7.32094 8.6405 7.76438 6.27872 8.46543 4.49372C8.84933 3.5162 9.32528 2.67373 9.89226 2.06311C9.91201 2.04185 9.93192 2.02081 9.95201 2C5.63433 2.91255 2.33352 6.65272 2 11.234Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.766C2.33352 17.3473 5.63433 21.0874 9.95201 22C9.93192 21.9792 9.91201 21.9581 9.89226 21.9369C9.32528 21.3263 8.84933 20.4838 8.46543 19.5063C7.76438 17.7213 7.32094 15.3595 7.2476 12.766H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.048 22C18.3657 21.0874 21.6665 17.3473 22 12.766H16.7524C16.6791 15.3595 16.2356 17.7213 15.5346 19.5063C15.1507 20.4838 14.6747 21.3263 14.1077 21.9369C14.088 21.9581 14.0681 21.9792 14.048 22Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.234C21.6665 6.65272 18.3657 2.91255 14.048 2C14.0681 2.02081 14.088 2.04185 14.1077 2.06311C14.6747 2.67373 15.1507 3.5162 15.5346 4.49372C16.2356 6.27872 16.6791 8.6405 16.7524 11.234H22Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86202 5.06272C9.24384 6.63673 8.82554 8.79794 8.75243 11.234H15.2476C15.1745 8.79794 14.7562 6.63673 14.138 5.06272C13.796 4.19202 13.4077 3.5388 13.0149 3.11579C12.6236 2.69439 12.2804 2.55286 12 2.55286C11.7196 2.55286 11.3764 2.69439 10.9851 3.11579C10.5923 3.5388 10.204 4.19202 9.86202 5.06272Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.138 18.9373C14.7562 17.3633 15.1745 15.2021 15.2476 12.766H8.75243C8.82554 15.2021 9.24384 17.3633 9.86202 18.9373C10.204 19.808 10.5923 20.4612 10.9851 20.8843C11.3764 21.3056 11.7196 21.4472 12 21.4472C12.2804 21.4472 12.6236 21.3056 13.0149 20.8843C13.4077 20.4612 13.796 19.808 14.138 18.9373Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.863bcb975ed29e7862b7fc18fe95828e.svg";
export { ForwardRef as ReactComponent };